import { _o } from "./helpers";

export const crmScriptsInit = (): void => {
  const crmPage = !!_o(document.getElementsByClassName("crm-page")).length;
  if (crmPage) {
    require("../crm/application");
  }
};
